import { client, errorValidation } from "./service";

export const getEventList = async function ({
    type
}) {
    try {
        let response = await client.get(`/event/list?type=${type || ''}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const createEvent = async function ({
    eventName, type
}) {
    try {
        let response = await client.post(`/event/create`, {
            eventName, type
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const updateEvent = async function ({
    _id, eventName, type
}) {
    try {
        let response = await client.post(`/event/update/${_id}`, {
            eventName, type
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const deleteJastip = async function ({
    _id
}) {
    try {
        let response = await client.get(`/me/${_id}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}